"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const contentContainerCss = core_1.css `
  text-align: center;
`;
const subtextCss = core_1.css `
  margin-top: ${theme_1.Spacing.small}px;
`;
const footerCss = core_1.css `
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  margin-top: ${theme_1.Spacing.medium}px;
`;
function SkipTestingModal(props) {
    const { onCancel, onSkip } = props;
    return (common_utils_1.isolateComponent(common_components_1.Modal, { onClose: onCancel, overflowY: "hidden", padding: 40 },
        common_utils_1.isolateComponent("div", { css: contentContainerCss },
            common_utils_1.isolateComponent("div", null,
                common_utils_1.isolateComponent(design_system_1.Text, { type: "header700" }, "Skip testing your trigger?")),
            common_utils_1.isolateComponent("div", { css: subtextCss },
                common_utils_1.isolateComponent(design_system_1.Text, { color: "grey500", type: "bodyText800" }, "Skipping the trigger test may cause problems when you set up the rest of your Zap."))),
        common_utils_1.isolateComponent("footer", { css: footerCss },
            common_utils_1.isolateComponent(design_system_1.Button, { color: "blue", hasShadow: true, onClick: onSkip }, "Skip test"),
            common_utils_1.isolateComponent(design_system_1.Spacer, { width: theme_1.Spacing.medium }),
            common_utils_1.isolateComponent(design_system_1.Button, { color: "grey", onClick: onCancel }, "Cancel"))));
}
exports.default = SkipTestingModal;
